<div #editor class="px-3">
  <div #toolbar id="labelEditorToolbar" class="labelEditorToolbar noselect" (mousedown)="labelEditorToolbarMouseDown($event)">
    <div class="d-flex">
      @if (isAdvancedMode) {
        <div>
          <span class="ql-formats">
            <select class="ql-color" (change)="labelEditorFormatUpdate('color')">
              <option label="#000000" selected=""></option><!-- black is default color, see CSS and LabelEditorUtils.DEFAULT_COLOR-->
              <option value="#ff0000" label="#ff0000"></option>
              <option value="#ffffff" label="#ffffff"></option>
              <option value="#0ef109" label="#0ef109"></option>
            </select>
          </span>
          <span class="ql-formats ql-divider">&nbsp;</span>
          <span class="ql-formats">
            <button #horizontalAlignLeftButton class="ql-align" value="" (click)="labelEditorFormatUpdate('align')"></button>
            <button #horizontalAlignCenterButton class="ql-align" value="center" (click)="labelEditorFormatUpdate('align')"></button>
            <button #horizontalAlignRightButton class="ql-align" value="right" (click)="labelEditorFormatUpdate('align')"></button>
          </span>
          <span class="ql-formats ql-divider">&nbsp;</span>
          <span id="verticalAlignButtons" class="ql-formats">
            <button #verticalAlignTopButton class="ql-align-vertical" value="top" (click)="verticalAlignTop()"></button>
            <button #verticalAlignMiddleButton class="ql-align-vertical" value="middle" (click)="verticalAlignMiddle()"></button>
            <button #verticalAlignBottomButton class="ql-align-vertical" value="bottom" (click)="verticalAlignBottom()"></button>
          </span>
        </div>
      }
    </div>
    <div>
      <span class="ql-formats">
        <button (click)="clearCells()" [disabled]="!isClearCellsEnabled" class="quill-text-button d-flex align-items-center gap-2">
          <app-svg-icon type="delete" size="medium-small"/>
          <span>{{'labelEditorPopup.label.clear_cells' | translate}}</span>
        </button>
      </span>
      <span class="ql-formats ql-divider">&nbsp;</span>
      <span #textRotationSpan class="ql-formats">
        <button class="quill-text-button-as-label">{{'labelEditorPopup.label.rotation' | translate}}:</button>
        <select #textRotationSelect class="custom-ql-select labelEditorTextRotation" (change)="textRotationUpdate()">
          @for (option of textRotationOptions; track option) {
            <option [value]="option.value">{{option.label}}&deg;</option>
          }
        </select>
      </span>
      <span class="ql-formats">
        <button (click)="rotateTextByStep()"><app-svg-icon type="rotate" size="medium-small"/></button>
      </span>
      <span class="ql-formats ql-divider">&nbsp;</span>
      <span #symbolSelectionSpan class="ql-formats">
        <select class="custom-ql-select labelEditorSymbolSelection" [(ngModel)]="selectedSymbol" (change)="updateSelectedSymbol($event.target.value)">
          @for (option of symbolOptions; track option) {
            <option [value]="option.value">{{option.label}}</option>
          }
        </select>
        <button class="quill-text-button" [disabled]="!isAddSymbolEnabled" (click)="addSymbol()">{{'charSelector.label.place_char' | translate}}</button>
      </span>
    </div>
    <div id="autoSpan">
      @if (isAdvancedMode) {
        <span class="ql-formats">
          <div class="form-check form-check-inline">
            <input #autoFormatByTextCheckCheckBox id="auto" class="quill-checkbox form-check-input" type="checkbox" name="auto"
                   tooltip [tooltipText]="'labelEditorPopup.tooltip.autoStyleCheckBoxLabel' | translate"
                   checked="true" (change)="autoFormatByTextCheckUpdate()">
            <label id="autoLabel" for="auto" role="button" class="quill-checkbox-label form-check-label"
                   tooltip [tooltipText]="'labelEditorPopup.tooltip.autoStyleCheckBoxLabel' | translate">{{'labelEditorPopup.label.autoStyleCheckBoxLabel' | translate}}</label>
          </div>
        </span>
        <span class="ql-formats" [class.disabled]="isAutoFormatByTextCheckSelected">
          <select class="ql-size labelEditorSizeControl" (change)="labelEditorFormatUpdate('size')">
            <option selected value="10px">5</option><!-- 10px is default font size, see CSS and LabelEditorUtils.DEFAULT_FONT_SIZE -->
            <option value="12px">6</option>
            <option value="14px">7</option>
            <option value="16px">8</option>
            <option value="18px">9</option>
            <option value="20px">10</option>
            <option value="22px">11</option>
            <option value="24px">12</option>
            <option value="28px">14</option>
            <option value="32px">16</option>
            <option value="36px">18</option>
            <option value="40px">20</option>
            <option value="44px">22</option>
            <option value="48px">24</option>
            <option value="52px">26</option>
            <option value="56px">28</option>
            <option value="72px">36</option>
          </select>
        </span>
        <span #textCompressionSpan class="ql-formats" [class.disabled]="isAutoFormatByTextCheckSelected">
          <select #textCompressionSelect class="custom-ql-select labelEditorTextCompression" (change)="textCompressionUpdate()">
            @for (option of textCompressionOptions; track option) {
              <option [value]="option.value">{{option.label}}&#37;</option>
            }
          </select>
        </span>
        <span class="ql-formats">
          <div class="form-check form-check-inline">
            <input id="uniformDirectPrintingFontSize"
                   class="quill-checkbox form-check-input"
                   type="checkbox"
                   name="uniformDirectPrintingFontSize"
                   [ngModel]="useUniformDirectPrintingFontSize"
                   (ngModelChange)="setUseUniformDirectPrintingFontSize($event)">
            <label for="uniformDirectPrintingFontSize" class="quill-checkbox-label form-check-label">
              {{ 'labelEditorPopup.label.uniformDirectPrintingFontSize' | translate }}
            </label>
          </div>
        </span>
      }
      </div>
    <div class="dialog-panel labeleditor-divider"></div>
    <div>
      @if (!markingSystemLabelModeEnabled()) {
        <span class="ql-formats">
          <button (click)="mergeCells()" [disabled]="!isMergeCellsEnabled" class="quill-text-button d-flex align-items-center gap-2" data-testid="labeleditor-merge-cells">
            <app-svg-icon type="merge-cells" size="medium-small"/>
            <span>{{'labelEditorPopup.label.merge_cells' | translate}}</span>
          </button>
        </span>
        <span class="ql-formats">
          <button (click)="divideCells()" [disabled]="!isDivideCellsEnabled" class="quill-text-button d-flex align-items-center gap-2">
            <app-svg-icon type="split-cells" size="medium-small"/>
            <span>{{'labelEditorPopup.label.divide_cells' | translate}}</span>
          </button>
        </span>
      }
      @for (multilineSelectDataEntry of multilineSelectData; track multilineSelectDataEntry) {
        <span class="ql-formats" [class.disabled]="currentMaxMultilineCount < 2" [hidden]="multilineSelectDataEntry.maxMultilineCount !== currentMaxMultilineCount">
          <button class="quill-text-button-as-label" [class.disabled]="currentMaxMultilineCount < 2">{{'labelEditorPopup.label.multiline_count' | translate}}:</button>
          <select #multilineSelect class="custom-ql-select labelEditorMultilineSelection" (change)="multilineUpdate($event.target.value)">
            @for (option of multilineSelectDataEntry.options; track option) {
              <option [value]="option.value">{{option.label}}</option>
            }
          </select>
        </span>
      }
      @if (!markingSystemLabelModeEnabled()) {
        <span class="ql-formats">
          <button (click)="joinLabelStrips()" [disabled]="!isJoinLabelStripsEnabled" class="quill-text-button d-flex align-items-center gap-2">
            <app-svg-icon type="merge" size="medium-small"/>
            <span>{{'context.menu.join_label_strips' | translate}}</span>
          </button>
        </span>
      } @else {
        <span class="ql-formats">
          <button (click)="copyCells()" [disabled]="!isCopyCellsEnabled" class="quill-text-button d-flex align-items-center gap-2">
            <app-svg-icon type="copy" size="medium-small"/>
            <span>{{'global.label.copy' | translate}}</span>
          </button>
        </span>
        <span class="ql-formats">
          <button (click)="copyFromExcel()" class="quill-text-button d-flex align-items-center gap-2">
            <app-svg-icon type="maintenance" size="medium-small"/>
            <span>{{'labelEditorPopup.label.copyFromExcelButton' | translate}}</span>
          </button>
        </span>
      }
    </div>
    <div class="dialog-panel labeleditor-divider"></div>
    <div id="labelEditorAssistantHeader" class="font-weight-bold">{{'labelEditorPopup.label.automatic_labeling' | translate}}</div>
    <div class="d-flex">
      <div class="d-flex me-3" [class.ql-formats]="markingSystemLabelModeEnabled()">
        <button class="quill-text-button" (click)="applyQuickMarking()" [disabled]="!isQuickMarkingAvailable">{{'labelEditorPopup.label.set_marking' | translate}}</button>
        <button class="quill-text-button-as-label" [disabled]="!isQuickMarkingAvailable">{{'labelEditorPopup.label.set_marking_from' | translate}}</button>
        <input id="quickMarkingFrom" type="text" class="form-control" autocomplete="off" [disabled]="!isQuickMarkingAvailable" [(ngModel)]="quickMarkingFrom" (change)="onQuickMarkingFromChange($event)" inputRestricter="^[0-9]*$" maxlength="10">
        <button class="quill-text-button-as-label" [disabled]="!isQuickMarkingAvailable">{{'labelEditorPopup.label.set_marking_to' | translate: {'0': quickMarkingTo} }}</button>
      </div>
      @if (!markingSystemLabelModeEnabled()) {
        <div class="d-flex">
          <span class="ql-formats">
            <button class="quill-text-button-as-label">{{'labelEditorPopup.label.set_marking_with_PEN' | translate}}</button>
          </span>
          <span class="ql-formats me-0">
            <div class="form-check form-check-inline me-0">
              <input id="withN" type="checkbox" class="quill-checkbox form-check" [(ngModel)]="withN" [disabled]="!isQuickMarkingAvailable || !isPENOptionsAvailable">
              <label for="withN" class="quill-checkbox-label form-check-label"></label>
            </div>
          </span>
          <span #symbolNSelectionSpan class="ql-formats" [class.disabled]="!isQuickMarkingAvailable || !isPENOptionsAvailable">
            <select class="custom-ql-select labelEditorSymbolSelection" [(ngModel)]="selectedNSymbol" (change)="onNSymbolChange()">
              @for (option of symbolNOptions; track option) {
                <option [value]="option.value">{{option.label}}</option>
              }
            </select>
          </span>
          <span class="ql-formats me-0">
            <div class="form-check form-check-inline me-0">
              <input id="withPE" type="checkbox" class="quill-checkbox form-check" [(ngModel)]="withPE" [disabled]="!isQuickMarkingAvailable || !isPENOptionsAvailable">
              <label for="withPE" class="quill-checkbox-label form-check-label"></label>
            </div>
          </span>
          <span #symbolPESelectionSpan class="ql-formats me-4" [class.disabled]="!isQuickMarkingAvailable || !isPENOptionsAvailable">
            <select class="custom-ql-select labelEditorSymbolSelection" [(ngModel)]="selectedPESymbol" (change)="onPESymbolChange()">
              @for (option of symbolPEOptions; track option) {
                <option [value]="option.value">{{option.label}}</option>
              }
            </select>
          </span>
        </div>
      }
    </div>
    <div>
      <span class="ql-formats">
        <button (click)="createAssistantPopup()" [disabled]="!isAssistantEnabled" class="quill-text-button d-flex align-items-center gap-2">
          <app-svg-icon type="settings" size="medium-small"/>
          <span>{{'labelEditorPopup.label.assistant' | translate}}</span>
        </button>
      </span>
    </div>
    <div class="dialog-panel labeleditor-divider"></div>
  </div>
  <div #markingAtPosition [hidden]="error()">
    <div class="d-flex justify-content-between noselect pb-2">
      <div>
        <span class="font-weight-bold">{{(markingSystemLabelModeEnabled() ? 'labelEditorPopup.label.edit_marking_card' : 'labelEditorPopup.label.change_marking_at_position') | translate}}</span>
        @if ((containsTextCheckErrors || containsTextCheckStrictConformityErrors) && !isDirectPrintingModeEnabled) {
          <app-svg-icon type="warning" color="#ff0029" size="medium-small" [inline]="true" class="ms-3"
            tooltip [tooltipText]="'labelEditorPopup.tooltip.unresolved_failed_checks' | translate" />
        }
      </div>
      @if (isChangeMarkingModeAvailable) {
        <a class="link" (click)="toggleDirectPrintingMode()">
          <app-svg-icon type="view" [inline]="true"/> {{(isDirectPrintingModeEnabled ? 'labelEditorPopup.label.show_marking_articles' : 'labelEditorPopup.label.show_direct_printing') | translate}}
        </a>
      }
    </div>
  </div>
  <div #labelEditor id="labelEditor" class="ql-editor labelEditor" style="display: none;" (keydown)="handleKeyDownEventOnLabelEditor($event)"
    (paste)="handlePasteInLabelEditor($event)" (copy)="handleCopyInLabelEditor($event)" (mouseenter)="handleMouseEnterInLabelEditor($event)" (mouseleave)="handleMouseLeaveInLabelEditor($event)"></div>
  <tabset #tabSet [hidden]="error()" class="label-editor-tabs" [class.nav-tabs-hidden]="isNavigationTabsHidden">
    @for (tableProvider of tableProviders(); track tableProvider; let i = $index) {
      <tab [active]="i === currentTabIndex" [customClass]="getTabCustomClasses(tableProvider)" (selectTab)="onTabChange(i)">
        <ng-template tabHeading>
          <span tooltip [tooltipText]="tableProvider.tabTooltipText">{{getTabLabel(tableProvider)}}</span>
        </ng-template>
        <label-editor-tab
                [tableProvider]="tableProvider"
                [targetState]="targetState()"
                [markingSystemLabelModeEnabled]="markingSystemLabelModeEnabled()"
                [isSelectedCellsDescriptionEnabled]="isSelectedCellsDescriptionEnabled"
                [afterTableChangeHandler]="afterTableChangeHandler"
                [afterTableScrollHorizontallyHandler]="afterTableScrollHandler"
                [afterTableScrollVerticallyHandler]="afterTableScrollHandler"
                [beforeTableOnCellMouseDownHandler]="beforeTableOnCellMouseDownHandler"
                [afterTableOnCellMouseOverHandler]="afterTableOnCellMouseOverHandler"
                [afterTableOnCellMouseOutHandler]="afterTableOnCellMouseOutHandler"
                [afterTablePasteHandler]="afterTablePasteHandler"
                [afterTableBeginEditingHandler]="afterTableBeginEditingHandler"
                [shouldDeselectCellsOnOutsideClickHandler]="shouldDeselectCellsOnOutsideClickHandler"
                [quillTableEditor]="quillTableEditor"
                [tableRenderingState]="tableRenderingState"
                [changeMultilineCount]="changeMultilineCountHandler"
                [mergeAndDivideCells]="mergeAndDivideCellsHandler"
                [height]="totalHeight() - toolbar.clientHeight - markingAtPosition.clientHeight - (editor.getElementsByClassName('nav-tabs')[0]?.clientHeight || 0) - info.clientHeight - footer.offsetHeight - 8"
                [isSelected]="tabSet.tabs[i].active"
                (tableCreatedEmitter)="onTableCreated($event)"
                (afterTableSelectionEndEmitter)="afterTableSelectionEnd()">
        </label-editor-tab>
      </tab>
    }
  </tabset>
  @if (error()) {
    <div class="labelEditor-error" [style.height.px]="totalHeight() - toolbar.clientHeight - info.clientHeight - footer.offsetHeight">
      <h4>{{error().title | translate}}</h4>
      <p>{{error().message | translate}}</p>
    </div>
  }
  <div #info class="labelEditor-info">
    @if (showDefaultLabelingBorderExplanation() && !error()) {
      <div class="py-2">
        {{'labelEditorPopup.label.defaultLabelingBorderExplanation' | translate}}
      </div>
    }
    @if (!markingSystemLabelModeEnabled() && canEditFavoriteArticles()) {
      <div class="small py-2">
        <a class="link" (click)="openFavoriteArticlesOrderPopup()">
          <app-svg-icon type="edit-pen" [inline]="true"/>{{'favoriteArticlesOrderPopup.title' | translate}}
        </a>
      </div>
    }
  </div>
</div>
<div #footer >
  @if (mode === LabelEditorMode.TEXT_CHECK_FAILED && isUnsavedChangesExist()) {
    <div class="labelEditor-footer">
      <button class="btn btn-secondary btn-cancel" (click)="cancel()">{{'global.label.cancel' | translate}}</button>
    </div>
  }
</div>
